import { render } from "./SafaLogo.vue?vue&type=template&id=c154947a&ts=true"
import script from "./SafaLogo.vue?vue&type=script&lang=ts"
export * from "./SafaLogo.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__